import { isPHEV } from '../../../../../utils/vehicle';
import { useI18n } from '@oneaudi/i18n-context';
import { useConsumptionTestCycleEntriesLookup } from './useConsumptionTestCycleEntriesLookup';
import { messages } from '../i18n/messages';
import { useRangeTestCycleEntriesLookup } from './useRangeTestCycleEntriesLookup';
import { isAllBlocklisted } from '../utils';
import { TestCycleTypesFromConfig, } from '@oneaudi/vtp-configuration-service';
export const useConsumptionEmissionData = (vehicle, testCycle, consumptionBlacklist, ceData) => {
    var _a, _b, _c;
    const emissionEntryLabel = useI18n(messages.emissionEntry);
    const plugInConsumptionLabel = useI18n(messages.testCycleLabels[testCycle.toLowerCase()].plugInCombined);
    const rangeHeadline = useI18n(messages.subheadline.range);
    const testCycleHeadline = useI18n(messages.subheadline[testCycle]);
    const linkUrl = ceData && testCycle === TestCycleTypesFromConfig.WLTP ? ceData === null || ceData === void 0 ? void 0 : ceData.wltpLink : ceData === null || ceData === void 0 ? void 0 : ceData.nedcLink;
    const linkMsg = messages.testCycles[testCycle.toLowerCase()].linkLabel;
    const linkLabel = useI18n(linkMsg);
    const consumptionTestCycleEntries = useConsumptionTestCycleEntriesLookup();
    const rangeTestCycleEntries = useRangeTestCycleEntriesLookup();
    const fuelData = [];
    let hasLowEmissions = false;
    if (!vehicle) {
        return {
            testCycleType: testCycle,
            headline: testCycleHeadline,
            linkLabel,
            linkUrl,
            fuelData,
            hasLowEmissions,
        };
    }
    const emissionNode = ((_a = vehicle.vlsEnergyProvision) === null || _a === void 0 ? void 0 : _a.hasNedc) || ((_b = vehicle.vlsEnergyProvision) === null || _b === void 0 ? void 0 : _b.hasWltp)
        ? vehicle.vlsEnergyProvision
        : vehicle.io;
    if ((emissionNode === null || emissionNode === void 0 ? void 0 : emissionNode.fuels) && (emissionNode.hasNedc || emissionNode.hasWltp)) {
        (_c = emissionNode.fuels) === null || _c === void 0 ? void 0 : _c.filter((fuel, index) => !isPHEV(vehicle) || index === 0).forEach((fuel) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            const consumptionData = (_a = consumptionTestCycleEntries
                .get(testCycle)) === null || _a === void 0 ? void 0 : _a.map((entry) => {
                var _a, _b, _c, _d, _e, _f, _g;
                const value = ((_e = (_d = (_c = (_b = (_a = fuel.consumption) === null || _a === void 0 ? void 0 : _a[testCycle]) === null || _b === void 0 ? void 0 : _b.dataSets) === null || _c === void 0 ? void 0 : _c.find((dataSet) => dataSet.isDefault)) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e[entry.key]) || '';
                const unit = (_g = (_f = fuel.consumption) === null || _f === void 0 ? void 0 : _f[testCycle]) === null || _g === void 0 ? void 0 : _g.unit;
                return (value && {
                    key: `${fuel.fuel.toLowerCase()}-${testCycle.toLowerCase()}-consumption-${entry.key}`,
                    label: entry.label,
                    testCycleType: testCycle,
                    value,
                    unit,
                });
            }).filter((entry) => entry && !isAllBlocklisted(consumptionBlacklist, entry.key));
            if (isPHEV(vehicle)) {
                const plugInFuel = emissionNode.fuels[1];
                const value = (_c = (_b = plugInFuel === null || plugInFuel === void 0 ? void 0 : plugInFuel.consumption) === null || _b === void 0 ? void 0 : _b[testCycle]) === null || _c === void 0 ? void 0 : _c.consolidated;
                const unit = (_e = (_d = plugInFuel === null || plugInFuel === void 0 ? void 0 : plugInFuel.consumption) === null || _d === void 0 ? void 0 : _d[testCycle]) === null || _e === void 0 ? void 0 : _e.unit;
                const key = `${plugInFuel.fuel.toLowerCase()}-${testCycle.toLowerCase()}-consumption-combined`;
                if (value && !isAllBlocklisted(consumptionBlacklist, key)) {
                    consumptionData === null || consumptionData === void 0 ? void 0 : consumptionData.push({
                        key,
                        testCycleType: testCycle,
                        label: plugInConsumptionLabel,
                        value,
                        unit,
                    });
                }
            }
            const emissionEntry = (_g = (_f = fuel.emission) === null || _f === void 0 ? void 0 : _f.co2) === null || _g === void 0 ? void 0 : _g[testCycle];
            const emissionValue = emissionEntry === null || emissionEntry === void 0 ? void 0 : emissionEntry.consolidated;
            hasLowEmissions = parseInt(emissionValue, 10) < 95;
            const emissionUnit = emissionEntry === null || emissionEntry === void 0 ? void 0 : emissionEntry.unit;
            const key = `${fuel === null || fuel === void 0 ? void 0 : fuel.fuel.toLowerCase()}-${testCycle.toLowerCase()}-emission-combined`;
            const emissionData = emissionValue &&
                !isAllBlocklisted(consumptionBlacklist, key) && {
                key,
                label: emissionEntryLabel,
                value: emissionValue,
                unit: emissionUnit,
                testCycleType: testCycle,
            };
            const fuelWithRange = isPHEV(vehicle)
                ? emissionNode.fuels.find((fuelItem) => fuelItem.range)
                : fuel;
            let range;
            if (((_h = fuelWithRange === null || fuelWithRange === void 0 ? void 0 : fuelWithRange.range) === null || _h === void 0 ? void 0 : _h[testCycle]) && rangeTestCycleEntries.has(testCycle)) {
                const rangeData = (_j = rangeTestCycleEntries
                    .get(testCycle)) === null || _j === void 0 ? void 0 : _j.map((entry) => {
                    var _a, _b, _c;
                    const value = ((_c = (_b = (_a = fuelWithRange.range[testCycle].dataSets) === null || _a === void 0 ? void 0 : _a.find((dataSet) => dataSet.isDefault)) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c[entry.key]) || '';
                    const { unit } = fuelWithRange.range[testCycle] || {};
                    return (value && {
                        key: `range-${testCycle.toLowerCase()}-${entry.key}`,
                        label: entry.label,
                        value,
                        unit,
                        testCycleType: testCycle,
                    });
                }).filter((entry) => entry && !isAllBlocklisted(consumptionBlacklist, entry.key));
                if (rangeData.length) {
                    range = {
                        headline: rangeHeadline,
                        data: rangeData,
                    };
                }
            }
            if (consumptionData && emissionData && consumptionData.length) {
                fuelData === null || fuelData === void 0 ? void 0 : fuelData.push(Object.assign({ emissionData, consumptionData }, (range && { range })));
            }
        });
    }
    return {
        testCycleType: testCycle,
        headline: testCycleHeadline,
        linkLabel,
        linkUrl,
        fuelData,
        hasLowEmissions,
    };
};
